import K_PopUpPane from "../templates/K_PopUpPane";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PopUpPaneOptions extends ComponentOptions {
    components: Component[];
    title?: string;
    header?: string;
    bindClass?: string;
    info?: boolean | "true";
    bsc?: string;
    childBsc?: string;
}

export class PopUpPane extends TemplateComponent {

    options: PopUpPaneOptions;
    content: {
        components: Component[];
    };

    constructor(options: PopUpPaneOptions) {
        super(K_PopUpPane, options);

        this.content = {
            components: options.components
        };
    }

    preRender() {
        const options = this.options;

        options.title = options.header;
        options.bindClass = options.bindClass || "bind-label";
        options.childBsc = options.childBsc || "col-xs-6";
        options.info = options.info || false;
    }

}
